import { render, staticRenderFns } from "./ChannelAddAndEditor.vue?vue&type=template&id=76866d51&scoped=true&"
import script from "./ChannelAddAndEditor.vue?vue&type=script&lang=js&"
export * from "./ChannelAddAndEditor.vue?vue&type=script&lang=js&"
import style0 from "./ChannelAddAndEditor.vue?vue&type=style&index=0&id=76866d51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76866d51",
  null
  
)

export default component.exports